import * as React from 'react';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import { ContentWrapper, StyledFlexRow, Title, TitleWrapper } from './Reviews';
import { DsiRelatedProduct as RelatedProduct } from './RelatedProduct';
import {
  getRelatedProductInfo,
  resolveCategoryUrl,
} from '../../../utilities/selectors';
import { StyledTitle } from './Description';
import { IconType, DsiSvgIcon as SvgIcon } from '../../Dsi/General/SvgIcon';
import { getImagePath } from '../../../utilities/product';
import { __ } from 'react-i18n';
import { Link } from 'react-router';

interface Props {
  categories: any;
  isOpen: boolean;
  apiUrl: string;
  title?: string;
  lang?: string;
}

function RelatedCategories(props: Props) {
  const { isOpen, categories, apiUrl, title, lang } = props;

  if (categories && categories.length === 0) {
    return <></>;
  }

  const renderRelatedCategory = (key, category) => {
    const picture = getImagePath(category.image);
    let url = resolveCategoryUrl(category.category_id, category.url,'CATEGORYTEXT/URL');
    let categoryName = category.category_name;

    if(lang && category?.publish?.length){
      const publish = category.publish.find(item => item.lang_id == lang);
      if(publish && publish.url){
        url = resolveCategoryUrl(category.category_id, publish.url,'CATEGORYTEXT/URL');
        categoryName = publish.category_name
      }
    }
    
    return (
      <ItemWrapper to={url} key={key}>
        <Image
          alt={`${__('Obrázok kategórie')} ${categoryName}`}
          src={picture ? `${picture}` : `/images/icons/placeholder.svg`}
        />
        <CategoryName> {categoryName} </CategoryName>
      </ItemWrapper>
    );
  };

  return (
    <>
      <StyledFlexRowNew isOpen={isOpen}>
        {categories && categories.length > 0 && (
          <>
            {title && (
              <TitleContainer>
                <IconContainer>
                  <SvgIcon icon={IconType.search} />
                </IconContainer>
                <StyledTitleNew>{title}</StyledTitleNew>
              </TitleContainer>
            )}
            <StyledContentWrapper>
              {categories &&
                categories.length > 0 &&
                categories.map((p: any, key) => renderRelatedCategory(key, p))}
            </StyledContentWrapper>
          </>
        )}
      </StyledFlexRowNew>
    </>
  );
}

const StyledFlexRowNew = styled(StyledFlexRow)`
  padding-top: ${rem(0)};
`;

const StyledTitleNew = styled(StyledTitle)`
  margin-bottom: 0;
`;

const IconContainer = styled.div`
  margin-right: ${rem(16)};
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(32)};
`;

const ItemWrapper = styled(Link)`
  display: flex;
  flex-direction: row;
  margin-right: ${rem(30)};
  max-height: ${rem(50)};
  background: #e3e3e3;
  padding-right: ${rem(10)};
  min-width: ${rem(200)};
  border-radius: ${rem(5)};
  font-size: ${rem(14)};
  text-decoration: none;
  color: ${({ theme }) => rgba(theme.colors.textPrimary, 1)};
  margin-bottom: ${rem(10)};

  ${({ theme }) => theme.mediab.m810`
        margin-right: 0px;
        width: 100%;
        padding-top: ${rem(15)};
    `}
`;

const StyledContentWrapper = styled(ContentWrapper)`
  ${({ theme }) => theme.mediab.m810`
        flex-direction: row;
    `}
`;

const Image = styled.img`
  object-fit: contain;
`;

const CategoryName = styled.div`
  display: flex;
  align-items: center;
`;

export { RelatedCategories as DsiRelatedCategories };
